module.exports = __webpack_public_path__ + "static/media/dog-duotone.80a83c53.svg";